export default __webpack_public_path__ + "static/media/im7.9e0782f3.jpg";